module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-420.adacd00.woff2";